import React from 'react';
export const CombineClasses = (...classNames) => {
    return classNames.filter((c) => c !== undefined && c !== null && c !== '').join(' ');
};
export const IsValidReactNode = (node) => {
    return typeof node === 'string' || typeof node === 'number' || React.isValidElement(node);
};
//# sourceMappingURL=ReactUtils.js.map